export default __webpack_public_path__ + "static/media/goals.c0810f5a.svg";